import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
const PROVINCES = ['Buenos Aires', 'Ciudad de Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba', 'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'];
const NAMES = ['María', 'Sofía', 'Valentina', 'Lucía', 'Camila', 'Martina', 'Julieta', 'Florencia', 'Agustina', 'Carolina', 'Micaela', 'Belén', 'Rocío', 'Antonella', 'Brenda', 'Daniela', 'Gabriela', 'Milagros', 'Ariana', 'Delfina'];
const PACKS = ['Pack Premium', 'Pack Digital'];
interface Sale {
  name: string;
  province: string;
  pack: string;
  minutesAgo: number;
}
const randomSale = (): Sale => ({
  name: NAMES[Math.floor(Math.random() * NAMES.length)],
  province: PROVINCES[Math.floor(Math.random() * PROVINCES.length)],
  pack: PACKS[Math.floor(Math.random() * PACKS.length)],
  minutesAgo: Math.floor(Math.random() * 14) + 1
});
export function PurchaseNotification() {
  const [sale, setSale] = useState<Sale | null>(null);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showSale = () => {
      setSale(randomSale());
      hideTimeout = setTimeout(() => setSale(null), 6000);
    };
    // First one shortly after load, then every 12 seconds
    const firstTimeout = setTimeout(showSale, 4000);
    const interval = setInterval(showSale, 12000);
    return () => {
      clearTimeout(firstTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] pointer-events-none" data-id="element-1">
      <AnimatePresence data-id="element-2">
        {sale && <motion.div key={`${sale.name}-${sale.province}-${sale.minutesAgo}`} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-start gap-3 bg-white rounded-2xl shadow-xl border border-slate-100 px-4 py-3 w-[300px]" data-id="element-3">
            <span className="shrink-0 w-10 h-10 rounded-full bg-[#FFF0F3] flex items-center justify-center" data-id="element-4">
              <ShoppingBag className="text-[#E85D75]" size={20} data-id="element-5" />
            </span>
            <div className="flex-1 min-w-0" data-id="element-6">
              <p className="text-sm font-bold text-slate-900 leading-snug" data-id="element-7">
                {sale.name} de {sale.province}
              </p>
              <p className="text-xs text-slate-600 leading-snug" data-id="element-8">
                acaba de comprar el{' '}
                <span className="font-medium text-slate-800" data-id="element-9">{sale.pack}</span>
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] text-green-600 font-medium" data-id="element-10">
                <CheckCircle2 size={12} data-id="element-11" /> Compra verificada · hace{' '}
                {sale.minutesAgo} min
              </p>
            </div>
            <button onClick={() => setSale(null)} aria-label="Cerrar notificación" className="shrink-0 text-slate-300 hover:text-slate-500 transition-colors" data-id="element-12">
              <X size={16} data-id="element-13" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}